import * as React from 'react';
import { ICheckoutClubInfoCollectorResources } from '../checkout-club-info-collector.props.autogenerated';
import { GiftData } from '../types/gift-type';
import { MemberData } from '../types/member-type';

export interface IDisplayInfo {
    aggregate: MemberData | GiftData;
    isForSelf: boolean;
    resources: ICheckoutClubInfoCollectorResources;
}

/**
 * displays aggregated information, non editable
 */
export class DisplayInfo extends React.Component<IDisplayInfo> {

    public render(): JSX.Element {
        if (this.props.isForSelf) {
            return this._selfJSX;
        } else {
            return this._giftJSX;
        }
    }

    public get _selfJSX(): JSX.Element {
        const {
            checkoutClubInfoCollector__memberFirstName,
            checkoutClubInfoCollector__memberLastName,
            checkoutClubInfoCollector__additionalMemberFirstName
        } = this.props.resources;

        const {
            firstName,
            lastName,
            additionalMemberFirstName
        } = this.props.aggregate as MemberData;

        return (
            <div className='checkout-club-info-collector-display'>
                <div className='checkout-club-info-collector-display-field'>
                    <span className='checkout-club-info-collector-display-field-name'>{checkoutClubInfoCollector__memberFirstName}</span>
                    <span className='checkout-club-info-collector-display-field-value'>{firstName}</span>
                </div>
                <div className='checkout-club-info-collector-display-field'>
                    <span className='checkout-club-info-collector-display-field-name'>{checkoutClubInfoCollector__memberLastName}</span>
                    <span className='checkout-club-info-collector-display-field-value'>{lastName}</span>
                </div>
                <div className='checkout-club-info-collector-display-field'>
                    <span className='checkout-club-info-collector-display-field-name'>{checkoutClubInfoCollector__additionalMemberFirstName}</span>
                    <span className='checkout-club-info-collector-display-field-value'>{additionalMemberFirstName}</span>
                </div>
            </div>
        );
    }

    public get _giftJSX(): JSX.Element {
        const {
            checkoutClubInfoCollector__giftFirstName,
            checkoutClubInfoCollector__giftLastName,
            checkoutClubInfoCollector__giftEmail,
            checkoutClubInfoCollector__giftPhoneNumber,
            checkoutClubInfoCollector__giftEndDate
        } = this.props.resources;

        const {
            firstName,
            lastName,
            email,
            phoneNumber,
            endDateSubmit
        } = this.props.aggregate as GiftData;

        return (
            <div className='checkout-club-info-collector-display'>
                <div className='checkout-club-info-collector-display-field'>
                    <span className='checkout-club-info-collector-display-field-name'>{checkoutClubInfoCollector__giftFirstName}</span>
                    <span className='checkout-club-info-collector-display-field-value'>{firstName}</span>
                </div>
                <div className='checkout-club-info-collector-display-field'>
                    <span className='checkout-club-info-collector-display-field-name'>{checkoutClubInfoCollector__giftLastName}</span>
                    <span className='checkout-club-info-collector-display-field-value'>{lastName}</span>
                </div>
                <div className='checkout-club-info-collector-display-field'>
                    <span className='checkout-club-info-collector-display-field-name'>{checkoutClubInfoCollector__giftEmail}</span>
                    <span className='checkout-club-info-collector-display-field-value'>{email}</span>
                </div>
                <div className='checkout-club-info-collector-display-field'>
                    <span className='checkout-club-info-collector-display-field-name'>{checkoutClubInfoCollector__giftPhoneNumber}</span>
                    <span className='checkout-club-info-collector-display-field-value'>{phoneNumber}</span>
                </div>
                {
                    endDateSubmit &&
                    <div className='checkout-club-info-collector-display-field'>
                        <span className='checkout-club-info-collector-display-field-name'>{checkoutClubInfoCollector__giftEndDate}</span>
                        <span className='checkout-club-info-collector-display-field-value'>{endDateSubmit}</span>
                    </div>
                }
            </div>
        );
    }
}